import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGoogleAds = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 48 48",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#ffc107",
			d: "m30.129 15.75-11.258-6.5-13 22 11.258 6.5z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#1e88e5",
			d: "M31.871 37.75c1.795 3.109 5.847 4.144 8.879 2.379 3.103-1.806 4.174-5.77 2.379-8.879l-13-22c-1.795-3.109-5.835-4.144-8.879-2.379-3.106 1.801-4.174 5.77-2.379 8.879l13 22z"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 11.5,
			cy: 34.5,
			r: 6.5,
			fill: "#43a047"
		})
	]
});
export default SvgGoogleAds;
